export const ADMIN_TABS = ['dashboard', 'bookings', 'customers', 'fleet', 'inventory', 'analytics', 'settings'] as const
export type Tab = typeof ADMIN_TABS[number]
export const analyticsViews = { overview: 'Overview', funnel: 'Funnel', acquisition: 'Acquisition', products: 'Products', journeys: 'Journeys', errors: 'Errors', checks: 'Postcode checks', 'ip-exclusions': 'IP exclusions' } as const
export type AnalyticsView = keyof typeof analyticsViews
export const settingsViews = { dates: 'Date settings', products: 'Product settings', areas: 'Delivery charges' } as const
export type SettingsView = keyof typeof settingsViews
export type AdminNavigation = { tab: Tab; analyticsView: AnalyticsView; settingsView: SettingsView }

export function navigationFromUrl(href: string): AdminNavigation {
  const params = new URL(href).searchParams
  const tab = params.get('tab')
  const view = params.get('view') || ''
  return {
    tab: tab === 'checks' ? 'analytics' : tab === 'dates' || tab === 'products' || tab === 'areas' || tab === 'delivery' ? 'settings'
      : tab === 'online' || tab === 'unassigned' ? 'bookings' : ADMIN_TABS.includes(tab as Tab) ? tab as Tab : 'dashboard',
    analyticsView: tab === 'checks' ? 'checks' : tab === 'analytics' && Object.hasOwn(analyticsViews, view) ? view as AnalyticsView : 'overview',
    settingsView: tab === 'dates' || tab === 'products' || tab === 'areas' ? tab
      : tab === 'settings' && Object.hasOwn(settingsViews, view) ? view as SettingsView : 'dates',
  }
}

export function navigationUrl(href: string, navigation: AdminNavigation): URL {
  const url = new URL(href)
  url.searchParams.set('tab', navigation.tab)
  if (navigation.tab === 'analytics') url.searchParams.set('view', navigation.analyticsView)
  else if (navigation.tab === 'settings') url.searchParams.set('view', navigation.settingsView)
  else url.searchParams.delete('view')
  return url
}
